// Tool type enum matching server values
export enum ToolType {
    AGENTIC_WORKFLOW = 'agenticWorkflow',
    MCP_TOOL = 'mcpTool',
    KNOWLEDGE_BASE = 'knowledgeBase',
    PROMPT_TOOL = 'promptTool'
}

// Tool type display names (can be internationalized later)
export const ToolTypeNames: Record<ToolType, string> = {
    [ToolType.AGENTIC_WORKFLOW]: 'Workflow',
    [ToolType.MCP_TOOL]: 'MCP-Werkzeug',
    [ToolType.KNOWLEDGE_BASE]: 'Wissensbasis',
    [ToolType.PROMPT_TOOL]: 'Prompt-Werkzeug'
};

// Function to get the appropriate icon for each tool type
export const getTypeIcon = (toolType: ToolType): string => {
    switch (toolType) {
        case ToolType.AGENTIC_WORKFLOW:
            return 'Flow';
        case ToolType.MCP_TOOL:
            return 'PlugConnected';
        case ToolType.KNOWLEDGE_BASE:
            return 'Library';
        case ToolType.PROMPT_TOOL:
            return 'ChatBot';
        default:
            return 'Settings';
    }
};

// Function to get display name for a tool type
export const getTypeDisplayName = (toolType: ToolType): string => {
    return ToolTypeNames[toolType] || 'Unknown Tool';
};

// Helper function to convert string to ToolType enum
export const stringToToolType = (typeString: string): ToolType => {
    switch (typeString.toLowerCase()) {
        case 'agenticworkflow':
        case 'agentic_workflow':
        case 'workflow':
        case 'workflows':
            return ToolType.AGENTIC_WORKFLOW;
        case 'mcptool':
        case 'mcp_tool':
        case 'mcp-werkzeug':
        case 'mcp tool':
            return ToolType.MCP_TOOL;
        case 'knowledgebase':
        case 'knowledge_base':
        case 'wissensbasis':
        case 'knowledge base':
            return ToolType.KNOWLEDGE_BASE;
        case 'prompttool':
        case 'prompt_tool':
        case 'prompt-werkzeug':
        case 'prompt tool':
            return ToolType.PROMPT_TOOL;
        default:
            return ToolType.AGENTIC_WORKFLOW; // Default fallback
    }
};
